/**
 * Shared accent-tone vocabulary for the LOCI motion atoms (DS 1.4.0 motion
 * layer). `teal` is the default city/app accent (no class); the others set
 * `--lm-accent` / `--lm-accent-glow` on the component root via the recolor
 * helpers in `loci-motion.css`.
 */
export type MotionTone = 'teal' | 'amber' | 'ember' | 'danger';

/** `tone` → `loci-motion.css` recolor class (teal is the bare default). */
export const MOTION_TONE_CLASS: Record<MotionTone, string> = {
  teal: '',
  amber: 'lm-amber',
  ember: 'lm-ember',
  danger: 'lm-danger',
};

/** Resolve a tone to its recolor class (`''` for teal / undefined). */
export function toneClass(tone: MotionTone | undefined): string {
  return tone ? MOTION_TONE_CLASS[tone] : '';
}

/** Join class fragments, dropping falsy values. */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
